import { FeeExceptionInterface } from '@/interfaces/FeeStructures.interface';
import BaseApiClient from '../BaseApiClient';

export interface CreateFeeExceptionPayload {
  companies: number[];
  allocations: {
    value?: number;
    fee_beneficiary_type_id: number;
  }[];
}

export class ApiFeeExceptions extends BaseApiClient {
  /**
   * Create fee exception
   */
  async create(
    feeScheduleId: number,
    payload: CreateFeeExceptionPayload
  ): Promise<FeeExceptionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/fee-versions/${feeScheduleId}/fee-exceptions`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Update fee exception
   */
  async update(
    feeExceptionId: number,
    payload: CreateFeeExceptionPayload
  ): Promise<FeeExceptionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .patch(`/fee-exceptions/${feeExceptionId}`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Delete fee exception
   */
  async delete(feeExceptionId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/fee-exceptions/${feeExceptionId}`, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.status === 204) {
            resolve();
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { feeExceptionsQueryKeys } from './query-keys';
export {
  useFeeExceptionsCreateMutation,
  useFeeExceptionsDeleteMutation,
  useFeeExceptionsUpdateMutation
} from './use-fee-exceptions-mutations';
export type {
  FeeExceptionsCreateVariables,
  FeeExceptionsUpdateVariables
} from './use-fee-exceptions-mutations';
